import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { User } from './../_models';
import { UserService, AuthenticationService } from './../_services';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { fadeAnimation } from './../app-routing.animation';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss'],
  animations: [fadeAnimation]
})
export class MainNavComponent {
  currentUser: User;
  currentUserSubscription: Subscription;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  //constructor(private breakpointObserver: BreakpointObserver) {}

  
  constructor(
      private router: Router,
      public loader: LoadingBarService,
      private breakpointObserver: BreakpointObserver,
      private authenticationService: AuthenticationService,
      private userService: UserService
  ) {
      this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
          this.currentUser = user;
      });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

}
